import React from 'react'
import DesignMentorship from './DesignMentorship'
import SupplyChainOptimization from './SupplyChainOptimization'
import Process from './Process'
import AIAgentCaseStudy from './AIAgentCaseStudy'
import PromoAI from './PromoAI'
import StoreInventoryOperations from './StoreInventoryOperations'
import Contact from './Contact'
import Home from './Home'
import ProfessionalProjects from './ProfessionalProjects'
import CreativeProjects from './CreativeProjects'
import Resume from './Resume'
import PromoUI from './PromoUI'
import About from './About'
import Admin from './Admin'
import DrawingIllustration from './DrawingIllustration'
import Painting from './Painting'
import Writing from './Writing'
import CreativeDesign from './CreativeDesign'
import VolunteerWork from './VolunteerWork'
import VolunteerCommunityDesign from './VolunteerCommunityDesign'
import Stories from './Stories'
import Story from './Story'
import SendToken from './SendToken'

export default { DesignMentorship, SupplyChainOptimization, Process, AIAgentCaseStudy, PromoAI, StoreInventoryOperations, Contact, Home, ProfessionalProjects, CreativeProjects, Resume, PromoUI, About, Admin, DrawingIllustration, Painting, Writing, CreativeDesign, VolunteerWork, VolunteerCommunityDesign, Stories, Story, SendToken }